/* eslint-disable no-undef */
import React, { useState } from "react"
import ReactDOM from 'react-dom/client';
import { InstantSearch,  Configure } from 'react-instantsearch';
import RelatedProducts from "./typeahead/relatedProducts"
// import anime from "animejs"
import { liteClient as algoliasearch } from 'algoliasearch/lite';

const root = document.querySelector(".related-products-react")
const relatedProductIds = root ? JSON.parse(root.getAttribute("data-relatedProducts")) : null

const credentials = ALGOLIA_CREDENTIALS || null
const searchClient = algoliasearch(credentials.appId, credentials.apiKey);

var facetFiltersArray = [] ;

  function createVir(id) {
	if( !facetFiltersArray.includes(`id:${id}` ))
	{
		facetFiltersArray.push(`id:${id}` );
	}
	   
	   return facetFiltersArray;
  }
function Typeahead(){
	  const [isActive, setActive] = useState( false );

	return ( <div className={"ais-InstantSearch__root"}> <div className="search-container">
		{relatedProductIds != null && 
        <RelatedProducts isActive={isActive} />
		}
    </div></div>)
}
  if (root && relatedProductIds.length > 0) {
	var facets = relatedProductIds.map(function( id ){ return createVir(id) })
	const root1Element = ReactDOM.createRoot( root );
	
 root1Element.render(
        <InstantSearch searchClient={searchClient} indexName="products"  >
            <Configure hitsPerPage={4} facetFilters={[facetFiltersArray]} />
			<Typeahead />			
        </InstantSearch>
    )
  }